import { makeGraphQLQuery } from '../request.gql';
import {queryFrontendConfiguration} from '../../frontendgql';

/**
 * Get Selection Schedule & Family
 * Initial Query for "Delegated - Login" process
 */
export const queryConfiguration = async ({token}) => {
    const {r,e} = await makeGraphQLQuery({
        query: `query {
            selection_schedule {
                hasSelection,
                isAllowUserCheckout,
                allowPaymentChoice,
                paymentMethod,
                selection {
                    id,
                    startDate,
                    endDate,   
                }
            }
            family {
                id
                projection
                client
                dependents {
                    id
                    name
                    relationship {
                        label,
                    }
                }
                coreMember {
                    id
                    name
                }
            }
            flexaccount {
                id
                name
                balance
            }
            leave_barter_config {
                id
                pricePerDay
                type
                daysAllowed
                enableDeduction
                isManagerApprovalRequired
                customWarningMessage
                status
                choice {
                  key
                  type
                  numOfDays
                  price
                }
                options {
                  key
                  type
                  numOfDays
                  price
                }
            }
        }`,
        variables: {},
        token,
    });
    if (e) return e;
    const frontendConfiguration = await queryFrontendConfiguration({token});
    if (frontendConfiguration instanceof Error) return frontendConfiguration;
    return {
        token,
        ...r.selection_schedule,
        ...frontendConfiguration,
        family: r.family,
        account: r.flexaccount,
        leaveBarter: r.leave_barter_config,
    };
};

export const queryAccountByEffectiveDate = async({token, effectiveDate}) => {
    const {r,e} = await makeGraphQLQuery({
        query: `query (
            $transactionDate: String!
        ) {
            flexaccountbyeffectivedate(
                transactionDate: $transactionDate
            ) {
                id
                name
                balance
            }
        }`,
        variables: {
            transactionDate: effectiveDate,
        },
        token,
    });
    if (e) return e;
    return r.flexaccountbyeffectivedate;
};
